import { render, staticRenderFns } from "./InstrucaoMedicao.vue?vue&type=template&id=088badac&scoped=true"
import script from "./InstrucaoMedicao.vue?vue&type=script&setup=true&lang=js"
export * from "./InstrucaoMedicao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstrucaoMedicao.vue?vue&type=style&index=0&id=088badac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088badac",
  null
  
)

export default component.exports